<script setup>
import { useMessage } from "@/composables/useMessage";
import { DateFormatter } from "@/utils/basics/date";
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonRow,
  IonTitle,
  IonToolbar,
  onIonViewWillEnter,
  IonBadge,
  IonItemSliding,
  IonItemOptions,
  IonItemOption,
} from "@ionic/vue";
import axios from "@/plugins/axios";
import { useStore } from "vuex";
import { ref } from "vue";
import { apiGetCases } from "@/api/user";

const store = useStore();
const { getMessages, messageTypeMapping } = useMessage();
onIonViewWillEnter(() => {
  store.commit("setShowLoading", true);
  apiGetCases();
  getMessages();
});

const isDateToday = (date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

const conversationList = ref(null);
const unread = async (conversation) => {
  let foundPartnerMessageId = null;
  for (const message of conversation.messages.toReversed()) {
    if (message.Partner && message.MessageId) {
      foundPartnerMessageId = message.MessageId;
      break;
    }
  }
  if (foundPartnerMessageId) {
    store.commit("setShowLoading", true);
    await axios.post("?Mode=General&Function=SetMessagesStatusNotRead", {
      Id: conversation.caseId,
      MessageId: foundPartnerMessageId,
    });
    store.commit("setShowLoading", true);
    await getMessages();
  }
  conversationList.value.$el.closeSlidingItems();
};
</script>

<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'roodie-safe' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
        <ion-title>Nachrichten</ion-title>
        <ion-button
          @click="store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          ></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid>
        <div
          v-if="
            store.state.conversations.length === 0 && !store.state.showLoading
          "
          class="ion-margin-top"
        >
          Sie haben aktuell noch keine Nachrichten.
        </div>
        <ion-list ref="conversationList" v-else>
          <template
            v-for="conversation of store.state.conversations"
            :key="conversation.caseId"
          >
            <ion-item-sliding>
              <ion-item
                :router-link="{
                  name: 'nachrichten-item',
                  params: { caseId: conversation.caseId },
                }"
                button
                :detail="false"
              >
                <ion-label>
                  <h3>
                    <ion-row>
                      <ion-col>
                        <b>{{
                          store.getters.casesById[conversation.caseId]
                            ?.PartnerId
                        }}</b>
                      </ion-col>
                      <ion-col size="auto">
                        <div
                          style="font-size: small"
                          :class="{
                            'u-color-primary u-bold':
                              store.getters.conversationsMessageCount
                                .conversations[conversation.caseId]?.count,
                          }"
                        >
                          {{
                            isDateToday(
                              new Date(conversation.messages.at(-1).Date)
                            )
                              ? DateFormatter.formatDate(
                                  new Date(conversation.messages.at(-1).Date),
                                  "HH:mm"
                                )
                              : DateFormatter.formatDate(
                                  new Date(conversation.messages.at(-1).Date),
                                  "DD.MM.YYYY"
                                )
                          }}
                        </div>
                      </ion-col>
                    </ion-row>
                  </h3>
                  <ion-row class="ion-align-items-center">
                    <ion-col class="ion-text-wrap">
                      <h3>
                        Service:
                        {{
                          messageTypeMapping[conversation.messages.at(-1).Type]
                        }}
                      </h3>
                    </ion-col>
                    <ion-col size="auto">
                      <div
                        class="c-badge"
                        v-if="
                          store.getters.conversationsMessageCount.conversations[
                            conversation.caseId
                          ]?.count
                        "
                      >
                        {{
                          store.getters.conversationsMessageCount.conversations[
                            conversation.caseId
                          ].count
                        }}
                      </div>
                    </ion-col>
                  </ion-row>
                  <p>{{ conversation.messages.at(-1).Message }}</p>
                </ion-label>
              </ion-item>
              <ion-item-options side="start">
                <ion-item-option @click="unread(conversation)"
                  >Ungelesen</ion-item-option
                >
              </ion-item-options>
            </ion-item-sliding>
          </template>
        </ion-list>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>
